import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const tripCreate = createAsyncThunk(
  "trip/tripCreate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.createTrip(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create trip");
    }
  }
);

export const changeStopOrders = createAsyncThunk(
  "trip/changeStopOrders",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.changeStopOrders(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to change stop orders");
    }
  }
);

export const fetchTripOverview = createAsyncThunk(
  "trip/fetchTripOverview",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.overviewTrip();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch trip overview");
    }
  }
);

export const tripLists = createAsyncThunk(
  "trip/tripLists",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.tripLists(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip");
    }
  }
);

export const viewAllTrips = createAsyncThunk(
  "trip/viewAllTrips",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.viewAllTrips();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch trips");
    }
  }
);

export const getTripDetails = createAsyncThunk(
  "trip/getTripDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.getTripDetails(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip details");
    }
  }
);

export const getTripLogs = createAsyncThunk(
  "trip/getTripLogs",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.getTripLogs(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip logs");
    }
  }
);

export const tripUpdate = createAsyncThunk(
  "trip/tripUpdate",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await apiService.updateTrip({ data });
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update trip");
    }
  }
);

export const fetchTripTimeline = createAsyncThunk(
  "trip/fetchTripTimeline",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.getTripTimeline(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch trip timeline");
    }
  }
);

export const generateTripId = createAsyncThunk(
  "trip/generateTripId",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.generateTripId();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to generate trip id");
    }
  }
);

export const getTripHistory = createAsyncThunk(
  "trip/getTripHistory",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getTripHistory(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip history");
    }
  }
);

export const commentOnTrip = createAsyncThunk(
  "trip/commentOnTrip",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.commentOnTrip(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to comment on trip");
    }
  }
);

export const changeTripStatus = createAsyncThunk(
  "trip/changeTripStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.changeTripStatus(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to change trip status");
    }
  }
);

export const tripStart = createAsyncThunk(
  "trip/tripStart",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.tripStart(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to start trip");
    }
  }
);

export const actualTripComplete = createAsyncThunk(
  "trip/actualTripComplete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.actualTripComplete(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to complete trip");
    }
  }
);

export const deleteTrip = createAsyncThunk(
  "trip/deleteTrip",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deleteTrip(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to delete trip");
    }
  }
);

export const tripSpeedChart = createAsyncThunk(
  "trip/tripSpeedChart",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.tripSpeedChart(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip speed chart");
    }
  }
);

export const tripViolations = createAsyncThunk(
  "trip/tripViolations",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await apiService.tripViolations(data, params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get trip violations");
    }
  }
);

export const saveGeofence = createAsyncThunk(
  "trip/saveGeofence",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.saveGeofence(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to save geofence");
    }
  }
);

export const getAllGeofence = createAsyncThunk(
  "trip/getAllGeofence",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getAllGeofence();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get all geofence");
    }
  }
);

export const deleteGeofence = createAsyncThunk(
  "trip/deleteGeofence",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deleteGeofence(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to delete geofence");
    }
  }
);

export const getPettyCashModes = createAsyncThunk(
  "trip/getPettyCashModes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getPettyCashModes();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get petty cash modes");
    }
  }
);

export const getPettyCashSource = createAsyncThunk(
  "trip/getPettyCashSource",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getPettyCashSource();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get petty cash source");
    }
  }
);

export const createPettyCash = createAsyncThunk(
  "trip/createPettyCash",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.createPettyCash(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create petty cash");
    }
  }
);

export const updatePettyCash = createAsyncThunk(
  "trip/updatePettyCash",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.updatePettyCash(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update petty cash");
    }
  }
);

export const deletePettyCash = createAsyncThunk(
  "trip/deletePettyCash",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deletePettyCash(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to delete petty cash");
    }
  }
);

export const getInspectionItems = createAsyncThunk(
  "trip/getInspectionItems",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.getInspectionItems(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get inspection items");
    }
  }
);

export const saveInspectedItems = createAsyncThunk(
  "trip/saveInspectedItems",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.saveInspectedItems(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to save inspected items");
    }
  }
);

export const expenseCategoryDropdown = createAsyncThunk(
  "trip/getExpenseCategoryDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getExpenseCategoryDropdown();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to get expense category dropdown");
    }
  }
);

export const createTripExpense = createAsyncThunk(
  "trip/createTripExpense",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.createTripExpense(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create trip expense");
    }
  }
);

export const updateTripExpense = createAsyncThunk(
  "trip/updateTripExpense",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.updateTripExpense(data);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to update trip expense");
    }
  }
);

export const deleteTripExpense = createAsyncThunk(
  "trip/deleteTripExpense",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.deleteTripExpense(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to delete trip expense");
    }
  }
);

const initialState = {
  data: [],
  tripCreateData: [],


  tripOverviewLoading: false,
  tripOverviewData: [],

  tripListsData: null,
  viewAllTripsData: [],
  viewAllTripsLoading: false,
  viewAllTripsError: null,

  tripDetailsLoading: false,
  tripDetailsData: {},

  tripTimelineData: [],
  tripGenerateIdData: [],
  changeTripStatusData: [],

  tripLogsLoading: false,
  tripLogsData: [],

  tripSpeedChartData: [],
  speedChartLoading: false,


  tripHistoryData: [],
  workOrderHistoryLoading: false,
  workOrderHistoryError: null,

  tripViolationsData: [],
  tripViolationsLoading: false,
  tripViolationsError: null,

  saveGeofenceData: [],
  saveGeofenceLoading: false,
  saveGeofenceError: null,

  getAllGeofenceData: [],
  getAllGeofenceLoading: false,
  getAllGeofenceError: null,

  deleteGeofenceLoading: false,
  deleteGeofenceError: null,

  pettyCashModesData: [],
  pettyCashModesLoading: false,
  pettyCashModesError: null,

  pettyCashSourceData: [],
  pettyCashSourceLoading: false,
  pettyCashSourceError: null,

  createPettyCashData: [],
  createPettyCashLoading: false,
  createPettyCashError: null,

  updatePettyCashLoading: false,
  updatePettyCashError: null,

  deletePettyCashLoading: false,
  deletePettyCashError: null,

  inspectionItemsData: [],
  inspectionItemsLoading: false,
  inspectionItemsError: null,

  saveInspectedItemsData: [],
  saveInspectedItemsLoading: false,
  saveInspectedItemsError: null,

  expenseCategoryDropdownData: [],
  expenseCategoryDropdownLoading: false,
  expenseCategoryDropdownError: null,

  createTripExpenseData: [],
  createTripExpenseLoading: false,
  createTripExpenseError: null,

  updateTripExpenseLoading: false,
  updateTripExpenseError: null,

  deleteTripExpenseLoading: false,
  deleteTripExpenseError: null,

  updateLoading: false,
  loading: false,
  timelineLoading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  totalRecords: 0,
  selectedTripId: null,
  viewAllTrips: false,
  activeTab: "live",
};

const tripSlice = createSlice({
  name: "trip",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setSelectedTripId: (state, action) => {
      state.selectedTripId = action.payload;
    },
    setViewAllTrips: (state, action) => {
      state.viewAllTrips = action.payload;
    },
    updateTripLiveData: (state, action) => {
      const { vehicle_id, lat, lng, speed, covered_distance, last_updated_at } =
        action.payload;

      const trip = state.tripListsData.find((t) => t.vehicle_id === vehicle_id);

      if (!trip) return;

      trip.covered_distance = Number(covered_distance) || 0;
      trip.last_updated_at = last_updated_at;

      if (!trip.trip_current_detail) {
        trip.trip_current_detail = {};
      }

      trip.trip_current_detail.lat = lat;
      trip.trip_current_detail.lng = lng;
      trip.trip_current_detail.speed = speed;
    },
    updateTripDetailsLiveData: (state, action) => {
      const { trip_id, lat, lng, speed } = action.payload;
      if (!state.tripDetailsData) return;
      if (state.tripDetailsData.id !== trip_id) return;
      if (!state.tripDetailsData.trip_current_detail) {
        state.tripDetailsData.trip_current_detail = {};
      }
      if (lat !== undefined)
        state.tripDetailsData.trip_current_detail.lat = lat;
      if (lng !== undefined)
        state.tripDetailsData.trip_current_detail.lng = lng;
      if (speed !== undefined)
        state.tripDetailsData.trip_current_detail.speed = speed;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(createTripExpense.pending, (state) => {
        state.createTripExpenseLoading = true;
        state.createTripExpenseError = null;
      })
      .addCase(createTripExpense.fulfilled, (state, action) => {
        state.createTripExpenseLoading = false;
        state.createTripExpenseData = action.payload;
        state.createTripExpenseError = null;
      })
      .addCase(createTripExpense.rejected, (state, action) => {
        state.createTripExpenseLoading = false;
        state.createTripExpenseError = action.payload;
      })

      .addCase(updateTripExpense.pending, (state) => {
        state.updateTripExpenseLoading = true;
        state.updateTripExpenseError = null;
      })
      .addCase(updateTripExpense.fulfilled, (state) => {
        state.updateTripExpenseLoading = false;
        state.updateTripExpenseError = null;
      })
      .addCase(updateTripExpense.rejected, (state, action) => {
        state.updateTripExpenseLoading = false;
        state.updateTripExpenseError = action.payload;
      })

      .addCase(deleteTripExpense.pending, (state) => {
        state.deleteTripExpenseLoading = true;
        state.deleteTripExpenseError = null;
      })
      .addCase(deleteTripExpense.fulfilled, (state) => {
        state.deleteTripExpenseLoading = false;
        state.deleteTripExpenseError = null;
      })
      .addCase(deleteTripExpense.rejected, (state, action) => {
        state.deleteTripExpenseLoading = false;
        state.deleteTripExpenseError = action.payload;
      })

      .addCase(expenseCategoryDropdown.pending, (state) => {
        state.expenseCategoryDropdownLoading = true;
        state.expenseCategoryDropdownError = null;
      })
      .addCase(expenseCategoryDropdown.fulfilled, (state, action) => {
        state.expenseCategoryDropdownLoading = false;
        state.expenseCategoryDropdownData = action.payload?.data;
        state.expenseCategoryDropdownError = null;
      })
      .addCase(expenseCategoryDropdown.rejected, (state, action) => {
        state.expenseCategoryDropdownLoading = false;
        state.expenseCategoryDropdownError = action.payload;
      })

      .addCase(saveInspectedItems.pending, (state) => {
        state.saveInspectedItemsLoading = true;
        state.saveInspectedItemsError = null;
      })
      .addCase(saveInspectedItems.fulfilled, (state, action) => {
        state.saveInspectedItemsLoading = false;
        state.saveInspectedItemsData = action.payload?.data;
        state.saveInspectedItemsError = null;
      })
      .addCase(saveInspectedItems.rejected, (state, action) => {
        state.saveInspectedItemsLoading = false;
        state.saveInspectedItemsError = action.payload;
      })

      .addCase(getInspectionItems.pending, (state) => {
        state.inspectionItemsLoading = true;
        state.inspectionItemsError = null;
      })
      .addCase(getInspectionItems.fulfilled, (state, action) => {
        state.inspectionItemsLoading = false;
        state.inspectionItemsData = action.payload?.data;
        state.inspectionItemsError = null;
      })
      .addCase(getInspectionItems.rejected, (state, action) => {
        state.inspectionItemsLoading = false;
        state.inspectionItemsError = action.payload;
        state.inspectionItemsData = [];
      })

      .addCase(tripCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(tripCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.tripCreateData = action.payload;
        state.error = null;
      })
      .addCase(tripCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tripCreateData = [];
      })
      .addCase(fetchTripOverview.pending, (state) => {
        state.tripOverviewLoading = true;
        state.error = null;
      })
      .addCase(fetchTripOverview.fulfilled, (state, action) => {
        state.tripOverviewLoading = false;
        state.tripOverviewData = action.payload?.data;
        state.error = null;
      })
      .addCase(fetchTripOverview.rejected, (state, action) => {
        state.tripOverviewLoading = false;
        state.error = action.payload;
        state.tripOverviewData = [];
      })
      .addCase(tripLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(tripLists.fulfilled, (state, action) => {
        state.loading = false;
        const responseData = action.payload?.data;

        if (responseData?.results) {
          const { results, meta } = responseData;
          state.totalPages = meta.totalPages;
          state.currentPage = meta.currentPage;
          state.totalRecords = meta.totalItems;

          state.tripListsData = results;
        } else {
          state.tripListsData = responseData || [];
          state.totalPages = 1;
          state.currentPage = 1;
          state.totalRecords = responseData?.length || 0;
        }
        state.error = null;
      })
      .addCase(tripLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tripListsData = [];
      })
      .addCase(viewAllTrips.pending, (state) => {
        state.viewAllTripsLoading = true;
        state.viewAllTripsError = null;
      })
      .addCase(viewAllTrips.fulfilled, (state, action) => {
        state.viewAllTripsLoading = false;
        state.viewAllTripsData = action.payload?.data || [];
        state.viewAllTripsError = null;
      })
      .addCase(viewAllTrips.rejected, (state, action) => {
        state.viewAllTripsLoading = false;
        state.viewAllTripsData = [];
        state.viewAllTripsError = action.payload;
      })
      .addCase(getTripDetails.pending, (state) => {
        state.tripDetailsLoading = true;
        state.error = null;
      })
      .addCase(getTripDetails.fulfilled, (state, action) => {
        state.tripDetailsLoading = false;
        state.tripDetailsData = action.payload?.data;
        state.error = null;
      })
      .addCase(getTripDetails.rejected, (state, action) => {
        state.tripDetailsLoading = false;
        state.error = action.payload;
        state.tripDetailsData = {};
      })
      .addCase(tripUpdate.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(tripUpdate.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.error = null;
      })
      .addCase(tripUpdate.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchTripTimeline.pending, (state) => {
        state.timelineLoading = true;
        state.error = null;
      })
      .addCase(fetchTripTimeline.fulfilled, (state, action) => {
        state.timelineLoading = false;
        state.tripTimelineData = action.payload?.data || [];
        state.error = null;
      })
      .addCase(fetchTripTimeline.rejected, (state, action) => {
        state.timelineLoading = false;
        state.tripTimelineData = [];
        state.error = action.payload;
      })
      .addCase(generateTripId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateTripId.fulfilled, (state, action) => {
        state.loading = false;
        state.tripGenerateIdData = action.payload?.data;
        state.error = null;
      })
      .addCase(generateTripId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tripGenerateIdData = [];
      })
      .addCase(getTripHistory.pending, (state) => {
        state.workOrderHistoryLoading = true;
        state.workOrderHistoryError = null;
      })
      .addCase(getTripHistory.fulfilled, (state, action) => {
        state.workOrderHistoryLoading = false;
        state.tripHistoryData = action.payload?.data || [];
        state.workOrderHistoryError = null;
      })
      .addCase(getTripHistory.rejected, (state, action) => {
        state.workOrderHistoryLoading = false;
        state.tripHistoryData = [];
        state.workOrderHistoryError = action.payload;
      })
      .addCase(changeTripStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeTripStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.changeTripStatusData = action.payload;
        state.error = null;
      })
      .addCase(changeTripStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.changeTripStatusData = [];
      })
      .addCase(tripStart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(tripStart.fulfilled, (state, action) => {
        state.loading = false;
        state.changeTripStatusData = action.payload;
        state.error = null;
      })
      .addCase(tripStart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(actualTripComplete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(actualTripComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(actualTripComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTripLogs.pending, (state) => {
        state.tripLogsLoading = true;
        state.error = null;
      })
      .addCase(getTripLogs.fulfilled, (state, action) => {
        state.tripLogsLoading = false;
        state.tripLogsData = action.payload?.data;
        state.error = null;
      })
      .addCase(getTripLogs.rejected, (state, action) => {
        state.tripLogsLoading = false;
        state.error = action.payload;
        state.tripLogsData = [];
      })
      .addCase(deleteTrip.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTrip.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteTrip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(tripSpeedChart.pending, (state) => {
        state.speedChartLoading = true;
        state.error = null;
      })
      .addCase(tripSpeedChart.fulfilled, (state, action) => {
        state.speedChartLoading = false;
        state.tripSpeedChartData = action.payload?.data;
        state.error = null;
      })
      .addCase(tripSpeedChart.rejected, (state, action) => {
        state.speedChartLoading = false;
        state.error = action.payload;
        state.tripSpeedChartData = [];
      })
      .addCase(tripViolations.pending, (state) => {
        state.tripViolationsLoading = true;
        state.error = null;
      })
      .addCase(tripViolations.fulfilled, (state, action) => {
        state.tripViolationsLoading = false;
        state.tripViolationsData = action.payload?.data;
        state.error = null;
      })
      .addCase(tripViolations.rejected, (state, action) => {
        state.tripViolationsLoading = false;
        state.error = action.payload;
        state.tripViolationsData = [];
      })
      .addCase(saveGeofence.pending, (state) => {
        state.saveGeofenceLoading = true;
        state.saveGeofenceError = null;
      })
      .addCase(saveGeofence.fulfilled, (state, action) => {
        state.saveGeofenceLoading = false;
        state.saveGeofenceData = action.payload?.data;
        state.saveGeofenceError = null;
      })
      .addCase(saveGeofence.rejected, (state, action) => {
        state.saveGeofenceLoading = false;
        state.saveGeofenceError = action.payload;
        state.saveGeofenceData = [];
      })
      .addCase(getAllGeofence.pending, (state) => {
        state.getAllGeofenceLoading = true;
        state.getAllGeofenceError = null;
      })
      .addCase(getAllGeofence.fulfilled, (state, action) => {
        state.getAllGeofenceLoading = false;
        state.getAllGeofenceData = action.payload?.data;
        state.getAllGeofenceError = null;
      })
      .addCase(getAllGeofence.rejected, (state, action) => {
        state.getAllGeofenceLoading = false;
        state.getAllGeofenceError = action.payload;
        state.getAllGeofenceData = [];
      })
      .addCase(deleteGeofence.pending, (state) => {
        state.deleteGeofenceLoading = true;
        state.deleteGeofenceError = null;
      })
      .addCase(deleteGeofence.fulfilled, (state) => {
        state.deleteGeofenceLoading = false;
        state.deleteGeofenceError = null;
      })
      .addCase(deleteGeofence.rejected, (state, action) => {
        state.deleteGeofenceLoading = false;
        state.deleteGeofenceError = action.payload;
      })
      .addCase(getPettyCashModes.pending, (state) => {
        state.pettyCashModesLoading = true;
        state.pettyCashModesError = null;
      })
      .addCase(getPettyCashModes.fulfilled, (state, action) => {
        state.pettyCashModesLoading = false;
        state.pettyCashModesData = action.payload?.data;
        state.pettyCashModesError = null;
      })
      .addCase(getPettyCashModes.rejected, (state, action) => {
        state.pettyCashModesLoading = false;
        state.pettyCashModesError = action.payload;
        state.pettyCashModesData = [];
      })
      .addCase(getPettyCashSource.pending, (state) => {
        state.pettyCashSourceLoading = true;
        state.pettyCashSourceError = null;
      })
      .addCase(getPettyCashSource.fulfilled, (state, action) => {
        state.pettyCashSourceLoading = false;
        state.pettyCashSourceData = action.payload?.data;
        state.pettyCashSourceError = null;
      })
      .addCase(getPettyCashSource.rejected, (state, action) => {
        state.pettyCashSourceLoading = false;
        state.pettyCashSourceError = action.payload;
        state.pettyCashSourceData = [];
      })
      .addCase(createPettyCash.pending, (state) => {
        state.createPettyCashLoading = true;
        state.createPettyCashError = null;
      })
      .addCase(createPettyCash.fulfilled, (state, action) => {
        state.createPettyCashLoading = false;
        state.createPettyCashData = action.payload?.data;
        state.createPettyCashError = null;
      })
      .addCase(createPettyCash.rejected, (state, action) => {
        state.createPettyCashLoading = false;
        state.createPettyCashError = action.payload;
        state.createPettyCashData = [];
      })

      .addCase(updatePettyCash.pending, (state) => {
        state.updatePettyCashLoading = true;
        state.updatePettyCashError = null;
      })
      .addCase(updatePettyCash.fulfilled, (state) => {
        state.updatePettyCashLoading = false;
        state.updatePettyCashError = null;
      })
      .addCase(updatePettyCash.rejected, (state, action) => {
        state.updatePettyCashLoading = false;
        state.updatePettyCashError = action.payload;
      })

      .addCase(deletePettyCash.pending, (state) => {
        state.deletePettyCashLoading = true;
        state.deletePettyCashError = null;
      })
      .addCase(deletePettyCash.fulfilled, (state) => {
        state.deletePettyCashLoading = false;
        state.deletePettyCashError = null;
      })
      .addCase(deletePettyCash.rejected, (state, action) => {
        state.deletePettyCashLoading = false;
        state.deletePettyCashError = action.payload;
      })
  },
});

export const {
  setCurrentPage,
  clearError,
  setSelectedTripId,
  updateTripLiveData,
  updateTripDetailsLiveData,
  setViewAllTrips,
  setActiveTab,
} = tripSlice.actions;

export default tripSlice.reducer;
